import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-property-info-pv.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-property-info-pv.component.scss?ngResource";
import { Component } from "@angular/core";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../../app-controller.service";
import { Store } from "@ngrx/store";
import { AutoUnsub } from "../../../../../../shared/decorators/autounsub.decorator";
import { allotmentAction, erfNoAction, farmNoAction, sgCodeAction } from "../../../../../../store/actions/Property-info.actions";
let SearchPropertyInfoPvComponent = class SearchPropertyInfoPvComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    store;
    propertyInfoErfNoLabel = ApplicationSearchConstants.FORM_CONTROLS.erfNoLabel;
    propertyInfoFarmNoLabel = ApplicationSearchConstants.FORM_CONTROLS.farmNoLabel;
    propertyInfoAllotmentLabel = ApplicationSearchConstants.FORM_CONTROLS.allotmentLabel;
    propertyInfoSgCodeLabel = ApplicationSearchConstants.FORM_CONTROLS.sgCodeLabel;
    propertyInfoErfNoFormControl = ApplicationSearchConstants.FORM_CONTROLS.erfNoFormControl;
    propertyInfoFarmNoFormControl = ApplicationSearchConstants.FORM_CONTROLS.farmNoFormControl;
    propertyInfoAllotmentFormControl = ApplicationSearchConstants.FORM_CONTROLS.allotmentFormControl;
    propertyInfoSgCodeFormControl = ApplicationSearchConstants.FORM_CONTROLS.sgCodeFormControl;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    propertyInfoForm;
    applicationSearchCallback;
    searchApplicationSubscription;
    erfNoStoreSubscription;
    farmNoStoreSubscription;
    allotmentStoreSubscription;
    sgCodeStoreSubscription;
    constructor(applicationSearchService, aflaModuleStrategyService, appController, store) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.store = store;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        let flagModule;
        const moduleHasChanged = this.store.select("modulesChanged");
        this.searchApplicationSubscription = moduleHasChanged.subscribe(mChanged => {
            flagModule = mChanged;
        });
        const erfNoStore = this.store.select("erfNo");
        this.erfNoStoreSubscription = erfNoStore.subscribe(val => {
            this.propertyInfoForm.get(this.propertyInfoErfNoFormControl).setValue(val);
        });
        const farmNoStore = this.store.select("farmNo");
        this.farmNoStoreSubscription = farmNoStore.subscribe(val => {
            this.propertyInfoForm.get(this.propertyInfoFarmNoFormControl).setValue(val);
        });
        const allotmentStore = this.store.select("allotment");
        this.allotmentStoreSubscription = allotmentStore.subscribe(val => {
            this.propertyInfoForm.get(this.propertyInfoAllotmentFormControl).setValue(val);
        });
        const sgCodeStore = this.store.select("sgCode");
        this.sgCodeStoreSubscription = sgCodeStore.subscribe(val => {
            this.propertyInfoForm.get(this.propertyInfoSgCodeFormControl).setValue(val);
        });
        const erfNo = this.propertyInfoForm.get(this.propertyInfoErfNoFormControl).value || "";
        const farmNo = this.propertyInfoForm.get(this.propertyInfoFarmNoFormControl).value || "";
        const allotment = this.propertyInfoForm.get(this.propertyInfoAllotmentFormControl).value || "";
        const sgCode = this.propertyInfoForm.get(this.propertyInfoSgCodeFormControl).value || "";
        this.applicationSearchCallback(this.applicationSearchService.searchByPropertyInfo(erfNo, farmNo, allotment, sgCode, this.aflaModuleStrategyService, Number(this.appController.selectedModuleID)));
        this.store.dispatch(erfNoAction({ value: erfNo }));
        this.store.dispatch(farmNoAction({ value: farmNo }));
        this.store.dispatch(allotmentAction({ value: allotment }));
        this.store.dispatch(sgCodeAction({ value: sgCode }));
    }
    setUpForm() {
        this.propertyInfoForm = new FormGroup({
            erfNoFormControl: new FormControl(""),
            farmNoFormControl: new FormControl(""),
            allotmentFormControl: new FormControl(""),
            sgCodeFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: Store }
    ];
};
SearchPropertyInfoPvComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-property-info-pv",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchPropertyInfoPvComponent);
export { SearchPropertyInfoPvComponent };
